import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AwardView, getAwardOptions } from '@/module/Author/Award';

export const Route = createFileRoute('/_auth/author/_author/award/_award/$awardId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { awardId } = Route.useParams();
  const { data: award } = useSuspenseQuery(getAwardOptions(awardId));

  return <AwardView award={award} />;
}
